<header>
  <app-navbar></app-navbar>
</header>
<main role="main"
      class="flex-even">
  <app-unsupported-browser-notification *ngIf="isUnsupportedBrowser()"></app-unsupported-browser-notification>
  <router-outlet>
    <app-spinner *ngIf="showSpinner"></app-spinner>
  </router-outlet>
</main>
<footer class="mt-auto">
  <app-footer></app-footer>
</footer>
